function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#cfd8dc;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "linha");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Camada_2",
  "data-name": "Camada 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Camada_1-2",
  "data-name": "Camada 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1,453.47c72.61,19.33,182.84,36.92,301.79,1.74,155.12-45.88,169.15-135.36,356.47-217.65,136.62-60,170.89-30.74,347.06-96.47A1365.3,1365.3,0,0,0,1281.5,1"
})));

var SvgLine = function SvgLine(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1282.5 476.39",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/line.7e6bc05c.svg";
export { ForwardRef as ReactComponent };